import React, { useState, useContext } from 'react';
import styled, { css } from 'styled-components';
import checkIcon from 'browser/assets/icons/check.svg';
import PropTypes from 'prop-types';
import { LangContext } from 'browser/contexts/LangContext';

const TERMS = {
  pl: [
    {
      formTermsText:
        'Wyrażam zgodę na prowadzenie marketingu bezpośredniego przy użyciu urządzeń telekomunikacyjnych, w szczególności telefonu, przez „Wyspę solną” Sp. z o.o. ul. Tadeusza Kościuszki 16, 78-100 Kołobrzeg „Vacation Investments” Sp. z o.o. z siedzibą w Warszawie, „Vacation Rental” Sp. z o.o. z siedzibą w Koszalinie, zgodnie z art. 172 ust. 1 ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne.',
    },
    {
      formTermsText:
        'Wyrażam zgodę na otrzymywanie informacji handlowych od „Wyspy solnej” Sp. z o.o. ul. Tadeusza Kościuszki 16, 78-100 Kołobrzeg, „Vacation Investments” Sp. z o.o. z siedzibą w Warszawie, „Vacation Rental” Sp. z o.o. z siedzibą w Koszalinie za pomocą środków komunikacji elektronicznej (na wskazany adres e-mail), zgodnie z art. 10 ust. 2 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną.',
    },
    {
      formTermsText:
        'Oświadczam, że zapoznałam/em się <a href="https://wyspasolna.pl/polityka-prywatnosci/" target="_top">z informacjami dotyczącymi przetwarzania danych osobowych.</a>',
    },
  ],
  en: [
    {
      formTermsText:
        'Wyrażam zgodę na prowadzenie marketingu bezpośredniego przy użyciu urządzeń telekomunikacyjnych, w szczególności telefonu, przez „Wyspę solną” Sp. z o.o. ul. Tadeusza Kościuszki 16, 78-100 Kołobrzeg „Vacation Investments” Sp. z o.o. z siedzibą w Warszawie, „Vacation Rental” Sp. z o.o. z siedzibą w Koszalinie, zgodnie z art. 172 ust. 1 ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne.',
    },
    {
      formTermsText:
        'Wyrażam zgodę na otrzymywanie informacji handlowych od „Wyspy solnej” Sp. z o.o. ul. Tadeusza Kościuszki 16, 78-100 Kołobrzeg, „Vacation Investments” Sp. z o.o. z siedzibą w Warszawie, „Vacation Rental” Sp. z o.o. z siedzibą w Koszalinie za pomocą środków komunikacji elektronicznej (na wskazany adres e-mail), zgodnie z art. 10 ust. 2 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną.',
    },
    {
      formTermsText:
        'Oświadczam, że zapoznałam/em się <a href="https://wyspasolna.pl/polityka-prywatnosci/" target="_top">z informacjami dotyczącymi przetwarzania danych osobowych.</a>',
    },
  ],
};

export const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 30px;
  margin: 10px 0;
  cursor: pointer;
  font-size: 1.2rem;
  text-align: left;
  &:first-of-type {
    margin-bottom: 13px;
    & > p {
      padding-top: 3px;
    }
  }
`;

const LabelBtn = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.mainFont};
  cursor: pointer;
  align-self: flex-start;
  padding: 2px 0 4px 10px;
  margin-left: auto;
`;

const LabelText = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  ${({ expanded }) =>
    expanded &&
    css`
      display: block;
      text-overflow: clip;
      -webkit-line-clamp: none;
      padding-top: 2px;
      word-break: normal;
    `}
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ big }) => (big ? '25px' : '20px')};
  width: ${({ big }) => (big ? '25px' : '20px')};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid;
  transition: 0.2s;
  border-color: ${({ theme, error }) =>
    error ? theme.colors.red : theme.colors.gray100};
  &:after {
    content: '';
    position: absolute;
    opacity: 0;
    transition: 0.2s;
    left: ${({ big }) => (big ? '6px' : '3px')};
    top: ${({ big }) => (big ? '5px' : '3px')};
    width: 12px;
    height: 12px;
    background: url(${checkIcon}) no-repeat center;
  }
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ ${Checkmark} {
    background: ${({ theme }) => theme.colors.primaryLight};
    border-color: ${({ theme }) => theme.colors.primaryLight};
    &:after {
      opacity: 1;
    }
  }
`;

const StyledLabelText = styled(LabelText)`
  font-weight: ${({ theme }) => theme.bold};
`;

const Terms = ({ setFieldValue, values, setErrors, errors, submitClicked }) => {
  const { lang, translate } = useContext(LangContext);

  const finalTerms = TERMS[lang].map(({ formTermsText }, index) => ({
    name: `agree${index + 1}Browser`,
    content: formTermsText,
    required: true,
  }));

  const initExpandedTerms =
    typeof window !== `undefined` && window.innerWidth >= 440
      ? []
      : finalTerms.map(({ name }) => name);
  const [expandedTerms, setExpandedTerms] = useState(initExpandedTerms);

  const handleCheckbox = name => {
    if (expandedTerms.includes(name)) {
      setExpandedTerms(expandedTerms.filter(term => term !== name));
    } else setExpandedTerms([...expandedTerms, name]);
  };

  const acceptAllKey = 'agreeAllBrowser';
  const agree1Key = 'agree1Browser';
  const agree2Key = 'agree2Browser';
  const agree3Key = 'agree3Browser';

  return (
    <>
      <Label htmlFor={acceptAllKey}>
        <StyledLabelText>{translate('acceptAll')}</StyledLabelText>
        <Checkbox
          id={acceptAllKey}
          name={acceptAllKey}
          type="checkbox"
          onChange={() => {
            if (!finalTerms.every(term => values[term.name] === true)) {
              setFieldValue(acceptAllKey, true);
              finalTerms.forEach(term => setFieldValue(term.name, true));
            } else {
              setFieldValue(acceptAllKey, true);
              finalTerms.forEach(term => setFieldValue(term.name, false));
            }
          }}
          checked={finalTerms.every(term => values[term.name] === true)}
        />
        <Checkmark />
      </Label>
      {finalTerms.map(({ name, content, required }) => (
        <Label htmlFor={name} key={name}>
          <LabelText expanded={expandedTerms.includes(name)}
            dangerouslySetInnerHTML={{__html: content}}
          />
          <LabelBtn type="button" onClick={() => handleCheckbox(name)}>
            {expandedTerms.includes(name)
              ? translate('less')
              : translate('more')}
          </LabelBtn>
          <Checkbox
            id={name}
            type="checkbox"
            onChange={() => {
              setFieldValue(name, !values[name]);
              required && setErrors({ ...errors, [agree1Key]: '' });
              required && setErrors({ ...errors, [agree2Key]: '' });
              required && setErrors({ ...errors, [agree3Key]: '' });
            }}
            checked={values[name]}
          />
          <Checkmark
            error={
              submitClicked &&
              (errors[agree1Key] || errors[agree2Key] || errors[agree3Key]) &&
              required &&
              values[name] === false
            }
          />
        </Label>
      ))}
    </>
  );
};

Terms.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  ).isRequired,
  setErrors: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  submitClicked: PropTypes.bool.isRequired,
};

export default Terms;
